module.exports = require("@fortawesome/pro-duotone-svg-icons");